/**
 * Filter key constants for the time-off type Changes tab.
 * Reused across the filter config, filter mapping hook, and the tab component.
 */
export const TIME_OFF_CHANGES_FILTER_KEY_DATE_RANGE = 'dateRange';
export const TIME_OFF_CHANGES_FILTER_KEY_CHANGED_BY = 'changedBy';
